/* eslint-disable */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box, Code, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import React from 'react';
import { JsiInterceptorRequest } from '../../interface/Crash';
import {
    JsiInterceptorBodySizeRow,
    RequestJsiInterceptorKindTag,
    RequestMethodTag,
    RequestStatusTag,
} from '../RequestTags';
import { JsiInterceptorCookieView } from './JsiInterceptorCookieView';
import { RequestHeaderView } from './RequestHeaderView';
import { ResponseHeaderView } from './ResponseHeaderView';

export const JsiInterceptorFrameRequestDetailsView: React.FC<{
    request: JsiInterceptorRequest;
}> = ({ request }) => {
    return (
        <>
            <Box>
                <Box as="span">
                    <RequestJsiInterceptorKindTag value={request.kind} />
                </Box>
                <Box as="span" paddingStart={2}>
                    <RequestStatusTag value={request.response?.status ?? '0'} />
                </Box>
                <Box as="span" paddingStart={2}>
                    <RequestMethodTag value={request.method} />
                </Box>
                <Text paddingStart={2} as="span" flex="1" fontWeight="semibold">
                    {request.url}
                </Text>
            </Box>
            <Tabs defaultIndex={0} pt={25}>
                <TabList>
                    {request.body && <Tab>Request Body</Tab>}
                    {request.response?.body && <Tab>Response Body</Tab>}
                    <Tab>Request Headers</Tab>
                    {request.response && <Tab>Response Headers</Tab>}
                    <Tab>Cookies Before</Tab>
                    {request.cookies_after && <Tab>Cookies After</Tab>}
                </TabList>

                <TabPanels>
                    {request.body && (
                        <TabPanel>
                            <JsiInterceptorBodySizeRow obj={request} />
                            <Code mt={5} p={3}>
                                {request.body}
                            </Code>
                        </TabPanel>
                    )}
                    {request.response?.body && (
                        <TabPanel>
                            <JsiInterceptorBodySizeRow obj={request.response} />
                            <Code mt={5} p={3}>
                                {request.response.body}
                            </Code>
                        </TabPanel>
                    )}
                    <TabPanel>
                        <RequestHeaderView request={request} />
                    </TabPanel>
                    {request.response && (
                        <TabPanel>
                            <ResponseHeaderView request={request} />
                        </TabPanel>
                    )}
                    <TabPanel>
                        <JsiInterceptorCookieView cookies={request.cookies_before} />
                    </TabPanel>
                    {request.cookies_after && (
                        <TabPanel>
                            <JsiInterceptorCookieView cookies={request.cookies_after} />
                        </TabPanel>
                    )}
                </TabPanels>
            </Tabs>
        </>
    );
};
